import { Context, createContext } from 'react';

const RequestsContext: Context<any> = createContext({});

export default RequestsContext;
